import { addCookieListener } from '@/lego/utils/navigator/cookies';

export default function boot(app) {
  addCookieListener('cookies_accept_analytics', function() {
    // Dependencias de Hotjar.
    (function(h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function() {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 5156035, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  })
    // Hotjar cargado con éxito.
    .then(function() {
      console.log('¡Dependencias de Hotjar cargadas!');
    })

    // Error al cargar Hotjar.
    .catch(function(error) {
      console.error('Ha ocurrido un error:');
      console.error(error);
    });
}
